import Gobalstore from "../index";
export const actions = {
  getEntreatyDetail: function (localStore, entId) {
    Gobalstore.commit("LoadingOverlay", true);
    localStore.state.ent_detail = {
      categories: [],
    };
    return new Promise((resolve, reject) => {
      this.axios({
        method: "GET",
        url: `/admin/guarded/main/entreaty/${entId}`,
      })
        .then(function (response) {
          localStore.commit("setEntreatyDetail", response.ents);
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((error) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(error);
        });
    });
  },

  editEntreaty: async function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    const body = localStore.state.ent_application;
    var that = this;
    return this.axios({
      method: "POST",
      url: "/admin/guarded/main/entreaty/edit/"+payload.ent_id,
      data: body,
      headers: payload.headers
    })
    .then((res) => {
      Gobalstore.commit("LoadingOverlay", false);
      return res;
    })
    .catch((err) => {
      Gobalstore.commit("LoadingOverlay", false);
      return err;
    });

  },

  getEntAll: function (localStore) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      localStore.dispatch("getEntProccess").then((res1) => {
        this.axios({
          method: "GET",
          url: `/admin/guarded/main/entreaties`,
        })
          .then(function (res2) {
            const payload = {
              entAll: res2.data,
              entPro: res1.data,
            };
            localStore.commit("setEntAll", payload);
            Gobalstore.commit("LoadingOverlay", false);
            resolve(payload);
          })
          .catch((error) => {
            Gobalstore.commit("LoadingOverlay", false);
            reject(error);
          });
      });
    })
   
  },

  getEntWaiting: function (localStore) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "GET",
      url: `/admin/guarded/main/entreaties/waiting`,
    })
    .then(function (res) {
        localStore.commit("setEntWaiting", res.data);
        Gobalstore.commit("LoadingOverlay", false);
        return res
    })
    .catch((error) => {
      Gobalstore.commit("LoadingOverlay", false);
      return error; 
    });  
   
  },

  getEntProcess: function (localStore) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "GET",
      url: `/admin/guarded/main/entreaties/processing`,
    })
    .then(function (res) {
        localStore.commit("setEntProcess", res.data);
        Gobalstore.commit("LoadingOverlay", false);
        return res
    })
    .catch((error) => {
      Gobalstore.commit("LoadingOverlay", false);
      return error; 
    });  
   
  },

  getEntDone: function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "POST",
      url: `/admin/guarded/main/entreaties/done`,
      data: payload
    })
    .then(function (res) {
        localStore.commit("setEntDone", res.data);
        Gobalstore.commit("LoadingOverlay", false);
        return res
    })
    .catch((error) => {
      Gobalstore.commit("LoadingOverlay", false);
      return error; 
    });  
   
  },

  postEntPaid: function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "POST",
      url: `/admin/guarded/main/entreaties/paid`,
      data: payload
    })
    .then(function (res) {
        localStore.commit("setEntPaid", res.data);
        Gobalstore.commit("LoadingOverlay", false);
        return res
    })
    .catch((error) => {
      Gobalstore.commit("LoadingOverlay", false);
      return error; 
    });  
   
  },

  postEntHandover: function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "POST",
      url: `/admin/guarded/main/entreaties/handover`,
      data: payload
    })
    .then(function (res) {
        localStore.commit("setEntHandover", res.data);
        Gobalstore.commit("LoadingOverlay", false);
        return res
    })
    .catch((error) => {
      Gobalstore.commit("LoadingOverlay", false);
      return error; 
    });  
   
  },

  uploadCertificate: function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "POST",
      url: `/admin/guarded/management/entreaty/uploadCertificate/`+payload.ent_id,
      data: payload.formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(function (res) {
        Gobalstore.commit("LoadingOverlay", false);
        return res
    })
    .catch((error) => {
      Gobalstore.commit("LoadingOverlay", false);
      return error; 
    });  
   
  },

  sortEntProccess: function (localStore, status) {
    var arrayStt = status.split("~");
    var filter = [...localStore.state.ent_pro].filter((value) =>
      arrayStt.includes(value.ent_status.to_status_code)
    );
    localStore.commit("setSortProcess", filter);
    
  },

  getEntPaid: function (localStore) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/admin/guarded/main/entreaties/paid`,
    })
      .then(function (response) {
        localStore.commit("setEntPiad", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  getEntDetail: function (localStore, ent_id) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "GET",
        url: `/admin/guarded/main/entreaty/${ent_id}`,
      })
        .then(function (response) {
          localStore.commit("setEntView", response.data);
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },

  viewDocument: function (localStore, { attach_id }) {
    return new Promise((resolve, reject) => {
      this.axios({
        method: "GET",
        url: `/admin/guarded/main/entreaty/view/${attach_id}`,
        responseType: "arraybuffer",
      })
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  },


  deleteDocument: function (localStore, { attach_id}) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "DELETE",
      url: `/admin/guarded/management/entreaty/remove-doc/${attach_id}`,
    })
    .then((res) => {
      Gobalstore.commit("LoadingOverlay", false);
      return res;
    })
    .catch((err) => {
      Gobalstore.commit("LoadingOverlay", false);
      return err;
    });
  },

  uploadDocument: function (localStore, { formData, ent_id, doc_code }) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "POST",
        url: `/admin/guarded/management/entreaty/upload/${ent_id}/${doc_code}`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => {
      Gobalstore.commit("LoadingOverlay", false);
      return res;
    })
    .catch((err) => {
      Gobalstore.commit("LoadingOverlay", false);
      return err;
    });
  },

  viewCertificate: function (localStore, { attach_id }) {
    return new Promise((resolve, reject) => {
      this.axios({
        method: "GET",
        url: `/admin/guarded/management/entreaty/viewCertificate/${attach_id}`,
        responseType: "arraybuffer",
      })
        .then(function (res) {
          resolve(res);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  },

  deleteCertificate: function (localStore, { attach_id}) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "DELETE",
      url: `/admin/guarded/management/entreaty/remove-certificate/${attach_id}`,
    })
    .then((res) => {
      Gobalstore.commit("LoadingOverlay", false);
      return res;
    })
    .catch((err) => {
      Gobalstore.commit("LoadingOverlay", false);
      return err;
    });
  },

  downloadDocument: function (localStore, { file_name, file_path }) {
    this.axios({
      method: "GET",
      url: `/admin/guarded/main/view/${file_path}/${file_name}`,
      responseType: "arraybuffer",
    }).then(function (res) {
      var url = window.URL.createObjectURL(new Blob([res.data]));
      var link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", file_name);
      document.body.appendChild(link);
      link.click();
    });
  },

  addBookmark: function (localStore, ent_id) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "POST",
      url: `/admin/guarded/main/entreaty/bookmark/${ent_id}`,
    })
      .then(function (response) {
        Gobalstore.commit("LoadingOverlay", false);
        Gobalstore.commit("snackbarSuccess", true);
        localStore.commit("removeOneEntAll", ent_id);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  deleteBookmark: function (localStore, ent_id) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "DELETE",
        url: `/admin/guarded/main/entreaty/bookmark/${ent_id}`,
      })
        .then(function (response) {
          Gobalstore.commit("LoadingOverlay", false);
          Gobalstore.commit("snackbarSuccess", true);
          localStore.commit("clearBookMark", ent_id);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },

  getStatusEnt: function (localStore, status_code) {
    this.axios({
      method: "GET",
      url: `/admin/guarded/main/status/${status_code}`,
    })
      .then(function (res) {
        Gobalstore.commit("LoadingOverlay", false);
        localStore.commit("setListStatusEnt", res.data);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  updateStatusEnt: function (localStore, payload) {
    
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "POST",
      url: `/admin/guarded/management/entreaty/updateStatus/${payload.entId}`,
      data: {
        "action": payload.action,
        "remark": payload.remark,
        "appointment": payload.appointment,
      },
      headers: payload.headers
    })
    .then(function (response) {
      Gobalstore.commit("LoadingOverlay", false);
      return response;
    })
    .catch((error) => {
      Gobalstore.commit("LoadingOverlay", false);
      return error;
    });
    
  },

  getTimeline: function (localStore, entId) {
    Gobalstore.commit("LoadingOverlay", true);
    return this.axios({
      method: "GET",
      url: `/admin/guarded/main/entreaty/timeline/${entId}`,
    })
      .then(function (response) {
        Gobalstore.commit("LoadingOverlay", false);
        return response;
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },
};
